import { FC, Fragment } from "react";
import ReleaseStep from "./ReleaseStep";
import { allReleasingSteps } from "./ReleaseSteps";
import StepVerticalDivider from "assets/patterns/VerticalDivider";

interface Props {
  activeStep: number;
}

const MobileProductReleaseSteps: FC<Props> = ({ activeStep }) => {
  return (
    <div className="relative flex items-center">
      <div className="flex flex-col gap-0.5 w-full items-start">
        {allReleasingSteps.map((step, i) => {
          const isDone = i <= activeStep;
          const isActive = i === activeStep;
          return (
            <Fragment key={i}>
              {i > 0 && (
                <div className="relative right-2.5">
                  <StepVerticalDivider />
                </div>
              )}
              <ReleaseStep {...{ isActive, isDone, step }} />
            </Fragment>
          );
        })}
      </div>
      {/* <SparklingIcon className="absolute right-0 z-10" /> */}
    </div>
  );
};

export default MobileProductReleaseSteps;
